import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { ref } from 'vue';
export default {
  __name: 'index',
  setup(__props) {
    const activeName = ref('home');
    setInterval(() => {
      console.log(activeName);
    }, 1000);
    return (_ctx, _cache) => {
      const _component_van_tabbar_item = _resolveComponent("van-tabbar-item");
      const _component_van_tabbar = _resolveComponent("van-tabbar");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_van_tabbar, {
        modelValue: activeName.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => activeName.value = $event)
      }, {
        default: _withCtx(() => [_createVNode(_component_van_tabbar_item, {
          name: "home",
          icon: "wap-home-o"
        }, {
          default: _withCtx(() => [_createTextVNode("主页")]),
          _: 1
        }), _createVNode(_component_van_tabbar_item, {
          name: "message",
          icon: "clock-o"
        }, {
          default: _withCtx(() => [_createTextVNode("消息中心")]),
          _: 1
        }), _createVNode(_component_van_tabbar_item, {
          name: "mine",
          icon: "location-o"
        }, {
          default: _withCtx(() => [_createTextVNode("我的")]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
};